import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import type { ExplicitAddress } from '@cronos-app/sdk';
import { Token } from '@ui/config/token';
import { useH2PriceImpact } from '@ui/hooks/h2/useH2PriceImpact';
import React from 'react';
import { BsExclamationCircle } from 'react-icons/bs';

import { Percent } from '../Num';
import { useH2SwapForm } from './components/H2SwapForm/useH2SwapForm';
import {
  useH2SwapFromTokenInfo,
  useH2SwapToTokenInfo,
} from './useH2SwapDialog';

const H2PriceImpact = () => {
  const { enteredAmount, fromToken } = useH2SwapForm();
  const fromTokenInfo = useH2SwapFromTokenInfo();
  const toTokenInfo = useH2SwapToTokenInfo();
  const mode = fromToken === Token.Agent ? 'sell-agent' : 'buy-agent';
  const impact = useH2PriceImpact({
    amountIn: enteredAmount,
    inputTokenAddress: fromTokenInfo?.address ?? '',
    inputTokenDecimals: fromTokenInfo?.decimals ?? 18,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    outputTokenAddress: (toTokenInfo?.address ?? '') as ExplicitAddress,
    outputTokenDecimals: toTokenInfo?.decimals ?? 18,
    mode,
  }).data;
  const isImpactHigh = impact?.gt(0.1);

  return (
    <>
      <HStack gap="4px">
        <Text textStyle="body2" mr="auto">
          Price impact
        </Text>
        <VStack
          align="flex-end"
          gap={0}
          color={isImpactHigh ? 'state.error' : undefined}
        >
          <Percent
            decimalPlaces={5}
            value={impact}
            textStyle="body2Bold"
            lineClamp={1}
            wordBreak="break-all"
          />
          {isImpactHigh && (
            <HStack textStyle="caption" gap="4px">
              <Icon asChild boxSize="12px">
                <BsExclamationCircle />
              </Icon>
              Warning! High price impact!
            </HStack>
          )}
        </VStack>
      </HStack>
    </>
  );
};

export default H2PriceImpact;
